import React from "react";
//#region redux
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "store";
import { ThunkDispatch } from "redux-thunk";
import { closeDialog, displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { DashboardButtonGroup, PageLayouts, StyledButton } from "components/common";
import * as Sentry from "@sentry/react";
import {
  useSupportTicketCreateDialog,
  useSupportTicketCreateDialogWithFAQ,
} from "components/support";
import TeamCard from "./TeamCard";
//#endregion
import { useSupportTeamContent } from "serviceHooks/useSupportTeamContent";
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import { useNavigate } from "react-router-dom";

const TeamPage: React.FC = () => {
  const companyId = useSelector((state: AppState) => state.auth.selectedCompany.id);
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const navigate = useNavigate();
  const { data, loading } = useSupportTeamContent(companyId);

  const { getDialog: getSupportTicketCreateDialog } = useSupportTicketCreateDialog();
  const supportTicketDialogWithFAQ = useSupportTicketCreateDialogWithFAQ(undefined, () => dispatch(closeDialog()));

  const onSupportButtonClick = () => {
    Sentry.captureMessage("Support team: Skicka meddelande clicked", { level: "info", tags: { source: "team-page" } });
    if (data?.team?.skipFaqStep) {
      dispatch(displayDialog(getSupportTicketCreateDialog(undefined, undefined, undefined, true)));
    } else {
      dispatch(displayDialog(supportTicketDialogWithFAQ));
    }
  };

  React.useEffect(() => {
    if (!loading && !data?.team) {
      navigate(UrlHelper.formatPath("/Support"), { replace: true });
    }
  }, [loading, data?.team, navigate]);

  if (loading || !data?.team) return null;

  const { team } = data;

  return (
    <PageLayouts.DashboardLayout
      entityKey={0}
      title={data.content?.teamPageTitle || LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.YourEconomyTeam)}
      topRightButtons={
        <DashboardButtonGroup
          buttons={[
            <StyledButton key="send-message" size="sm" onClick={onSupportButtonClick}>
              {data.content?.sendMessageTitle || LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SendMessage)}
            </StyledButton>,
          ]}
        />
      }
    >
      <Grid item xs={12}>
        <div className={cssExports.teamPageGrid}>
          {team.members.map((member) => (
            <TeamCard key={member.imageUrl} member={member} />
          ))}
        </div>
      </Grid>
    </PageLayouts.DashboardLayout>
  );
};

export default TeamPage;
